import { XIcon } from 'lucide-react';

import { Badge } from '@/ux-common/components/badge/badge';
import { Button } from '@/ux-common/components/button/button';
import {
  Header,
  HeaderActions,
  HeaderIcon,
  HeaderTitle,
} from '@/ux-common/components/header/header';
import { Typography } from '@/ux-common/components/typography/typography';

import { RESET_FAULTED_TITLE } from '../reset-faulted.constants';

interface ResetFaultedHeaderProps {
  deviceCount: number;
  onClose: () => void;
}

export const ResetFaultedHeader = ({ deviceCount, onClose }: ResetFaultedHeaderProps) => {
  return (
    <Header data-component="ResetFaultedHeader" data-testid="reset-faulted-header">
      <HeaderIcon>
        <Badge className="badge badge-default badge-pill">{deviceCount}</Badge>
      </HeaderIcon>
      <HeaderTitle>
        <Typography as="p" className="text-body text-primary uppercase leading-none">
          {RESET_FAULTED_TITLE}
        </Typography>
      </HeaderTitle>
      <HeaderActions>
        <Button
          aria-label="Close"
          className="btn btn-tier2 btn-md btn-circle"
          data-testid="reset-faulted-close-button"
          onClick={onClose}
        >
          <XIcon className="btn-icon" aria-hidden="true" />
        </Button>
      </HeaderActions>
    </Header>
  );
};
